export default Object.freeze({
  1: 'approved',
  2: 'rejected',
  3: 'signed',
  4: 'taskExecuted',
  5: 'saved',
  6: 'completed',
  7: 'savedAndCompleted',
});
